(() => {
  const state = {
    gtmLoaded: false,
    uetLoaded: false,
    merchantWidgetLoaded: false,
    initialized: false,
  };

  const destinations = window.FireballDirectDestinations || {};
  const debugEnabled = new URLSearchParams(window.location.search).has('fireball_tracking_debug');

  function debug(message) {
    if (debugEnabled) {
      console.info(`[Fireball tracking] ${message}`);
    }
  }

  function getCustomerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function hasConsent(method) {
    const customerPrivacy = getCustomerPrivacy();
    return Boolean(customerPrivacy && typeof customerPrivacy[method] === 'function' && customerPrivacy[method]());
  }

  function loadScript(source, id, onLoad) {
    if (document.getElementById(id)) return;

    const script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = source;
    script.onload = onLoad;
    document.head.appendChild(script);
  }

  function loadGtm() {
    if (state.gtmLoaded || !destinations.gtmEnabled || !destinations.gtmId || !hasConsent('marketingAllowed')) return;

    state.gtmLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    loadScript(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(destinations.gtmId)}`, 'fireball-gtm', () => {
      debug('GTM loaded after marketing consent.');
    });
  }

  function loadUet() {
    if (state.uetLoaded || !destinations.uetTagId || !hasConsent('marketingAllowed')) return;

    state.uetLoaded = true;
    window.uetq = window.uetq || [];
    loadScript('https://bat.bing.com/bat.js', 'fireball-uet', () => {
      if (typeof window.UET !== 'function') {
        state.uetLoaded = false;
        return;
      }

      const options = { ti: destinations.uetTagId, enableAutoSpaTracking: true, q: window.uetq };
      window.uetq = new window.UET(options);
      window.uetq.push('pageLoad');
      debug('Microsoft UET loaded after marketing consent.');
    });
  }

  function loadMerchantWidget() {
    if (state.merchantWidgetLoaded || !destinations.merchantWidget || !hasConsent('marketingAllowed')) return;

    state.merchantWidgetLoaded = true;
    loadScript('https://www.gstatic.com/shopping/merchant/merchantwidget.js', 'fireball-merchant-widget', () => {
      if (!window.merchantwidget) return;

      window.merchantwidget.start(destinations.merchantWidget);
      debug('Google store widget started after marketing consent.');
    });
  }

  function applyConsent() {
    loadGtm();
    loadUet();
    loadMerchantWidget();
  }

  function initializeCustomerPrivacy() {
    if (state.initialized) return;
    state.initialized = true;

    applyConsent();
    document.addEventListener('visitorConsentCollected', applyConsent, { passive: true });
  }

  function initialize() {
    if (!window.Shopify) {
      debug('Shopify Customer Privacy API is unavailable; direct destinations remain unloaded.');
      return;
    }

    if (typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: (error) => {
            if (error) {
              debug('Shopify Customer Privacy API failed to load; direct destinations remain unloaded.');
              return;
            }

            initializeCustomerPrivacy();
          },
        },
      ]);
      return;
    }

    initializeCustomerPrivacy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
